import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { routesMapping } from '../utils';

const DEFAULT_DESCRIPTION = 'Beyond the electronic health record system: elevating physician workflow';

export const usePageData = () => {
  const { pathname } = useLocation();
  const { title, description, withoutIndexing } = useMemo(() => routesMapping(pathname)?.meta || {}, [pathname]);

  return {
    title,
    description: description || DEFAULT_DESCRIPTION,
    url: `${process.env.REACT_APP_HOST}${pathname}`,
    withoutIndexing: Boolean(withoutIndexing) || process.env.REACT_APP_TYPE !== 'production',
  };
};

export const filterMeta = [
  'meta[name=description]',
  "meta[property='og:title']",
  "meta[property='og:description']",
  "meta[property='og:url']",
  "meta[name='twitter:title']",
  "meta[name='twitter:description']",
  'meta[name=robots]',
];
